import React, { useState, useEffect, useCallback } from 'react'
// import { Modal } from '@mui/material'
import { Modal } from 'components'

import NotFoundMessage from 'components/NotFoundMessage'
import ReviewRow from './ReviewRow'
import styles from './styles'
import ReviewAnalysis from './ReviewAnalysis'

function ReviewTable(props) {
  const { reviews, reloadData } = props

  const classes = styles()

  const [modal, setModal] = useState(false)
  const [clickedUUID, setClickedUUID] = useState(null)
  const [review, setReview] = useState(null)

  const handleCloseModal = () => {
    setModal(false)
    reloadData()
  }

  const handleOpenModal = (event) => {
    const uuid = event.target.id
    setClickedUUID(uuid)
  }

  const getReview = useCallback(
    (review_id) => {
      return reviews.find((rev) => review_id === rev.uuid)
    },
    [reviews],
  )

  useEffect(() => {
    if (clickedUUID) setReview(getReview(clickedUUID))
  }, [clickedUUID, getReview])

  useEffect(() => {
    if (review) setModal(true)
  }, [review])

  return (
    <React.Fragment>
      {reviews?.length > 0 ? (
        <table className={classes.dataTable}>
          <thead>
            <tr>
              <th>Data de derivação para análise</th>
              <th>nome</th>
              <th>cpf</th>
              <th>data de nascimento</th>
              <th>Ponto de atenção</th>
              <th className="middle-col">Revisor</th>
              <th className="middle-col">Status da análise</th>
              <th className="middle-col">Resultado</th>
              <th className="middle-col">análises</th>
            </tr>
          </thead>
          <tbody>
            {reviews?.map((rev) => (
              <ReviewRow
                key={rev.uuid}
                onClick={handleOpenModal}
                review={rev}
              />
            ))}
          </tbody>
        </table>
      ) : (
        <div className={classes.noData}>
          <NotFoundMessage message='Nenhum registro encontrado' />
        </div>
      )}
      {clickedUUID && (
        <Modal
          open={modal}
          onClose={handleCloseModal}
          title="Análise de Background Check"
        >
          <ReviewAnalysis reviewData={review} />
        </Modal>
      )}
    </React.Fragment>
  )
}
export default ReviewTable
